import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class T2 extends Component {
  render() {
    return (
      <div style={{ paddingTop: '0' }}>
        <div className="container-fluid" id="shopKeeper">
          <h4 className="">Category Page</h4>
          <br />
          <br />
          {/* <div className="col-lg-1 col-sm-2"></div> */}
          <div id="shopCard" width="100%">
            <div className="row">
              <div className="col-4 col-lg-2">
                <img
                  src="./img/product/1.jpeg"
                  alt=""
                  width="80%"
                  style={{ maxHeight: '100px', borderRadius: '10px' }}
                />
              </div>
              <div className="col-8">
                <h4>Central Perk</h4>
                <h5>Open from 9:00 A.M to 10:00 P.M</h5>
                <h6> Cras purus odio, vestibulum</h6>
              </div>
            </div>
          </div>
        </div>

        <section className="category-section spad">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 order-2 order-lg-1">
                <div className="filter-widget">
                  <h2 className="fw-title">Categories</h2>
                  <ul className="category-menu">
                    <li>
                      <a href="//#endregion">Woman wear</a>
                      <ul className="sub-menu">
                        <li>
                          <a href="//#endregion">
                            Midi Dresses <span>(2)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Maxi Dresses<span>(56)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Prom Dresses<span>(36)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Little Black Dresses <span>(27)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Mini Dresses<span>(19)</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="//#endregion">Man Wear</a>
                      <ul className="sub-menu">
                        <li>
                          <a href="//#endregion">
                            Midi Dresses <span>(2)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Maxi Dresses<span>(56)</span>
                          </a>
                        </li>
                        <li>
                          <a href="//#endregion">
                            Prom Dresses<span>(36)</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="//#endregion">Children</a>
                    </li>
                    <li>
                      <a href="//#endregion">Bags &amp; Purses</a>
                    </li>
                    <li>
                      <a href="//#endregion">Eyewear</a>
                    </li>
                    <li>
                      <a href="//#endregion">Footwear</a>
                    </li>
                  </ul>
                </div>{' '}
              </div>
              <div className="col-lg-9  order-1 order-lg-2 mb-5 mb-lg-0">
                <div className="row ml-auto mr-auto">
                  <div className="col-12">
                    <h2>Products</h2>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-12 col-lg-6 display p-4 mb-5">
                    <Link to="/product" className="cardLink">
                      <div className="row" style={{ height: '500px' }}>
                        <div className="row">
                          <div className="col-3">
                            <img
                              src="./img/product/1.jpeg"
                              alt=""
                              width="100%"
                            />
                            {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                          </div>
                          <div className="col-6">
                            <h5>Flamboyant Pink Top</h5>
                            <p>Cras sit amet nibh libero, in gravida nulla.</p>
                            {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                          </div>
                          <div className="col-3">
                            <button className="btn btnAdd">
                              {' '}
                              <i className="fa fa-plus"></i> Add
                            </button>
                            <h4>
                              <span className="badge badge-info mt-4 ">
                                $34.99
                              </span>
                            </h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <img
                              src="./img/product/1.jpeg"
                              alt=""
                              width="100%"
                            />
                            {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                          </div>
                          <div className="col-6">
                            <p>Cras sit amet nibh libero, in gravida nulla.</p>
                            {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                          </div>
                          <div className="col-3">
                            <button className="btn btnAdd">
                              {' '}
                              <i className="fa fa-plus"></i> Add
                            </button>
                            <h4>
                              <span className="badge badge-info mt-4 ">
                                $34.99
                              </span>
                            </h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <img
                              src="./img/product/1.jpeg"
                              alt=""
                              width="100%"
                            />
                            {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                          </div>
                          <div className="col-6">
                            <p>Cras sit amet nibh libero, in gravida nulla.</p>
                            {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                          </div>
                          <div className="col-3">
                            <button className="btn btnAdd">
                              {' '}
                              <i className="fa fa-plus"></i> Add
                            </button>
                            <h4>
                              <span className="badge badge-info mt-4 ">
                                $34.99
                              </span>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default T2;
